export default "__VITE_ASSET__0d057b1e__"